import { WalletProviderKind } from "../../enums/walletProvider";

export enum WalletEnum {
  METAMASK = 1,
  WALLETCONNECT = 2,
  WALLETLINK = 3,
  BRAVE = 4,
  EIP6963 = 5,
  // SDK-backed wallets (bridged into web3-react). These identify which SDK modal
  // produced the active connection so the UI can show the right name/icon.
  PRIVY = 6,
  PARA = 7,
  DOGEOS = 8,
}

export const WALLET_NAMES: Record<WalletEnum, string> = {
  [WalletEnum.METAMASK]: "Metamask",
  [WalletEnum.WALLETCONNECT]: "Wallet Connect",
  [WalletEnum.WALLETLINK]: "Coinbase Wallet",
  [WalletEnum.BRAVE]: "Brave",
  [WalletEnum.EIP6963]: "Browser Wallet",
  [WalletEnum.PRIVY]: "Privy",
  [WalletEnum.PARA]: "Para",
  [WalletEnum.DOGEOS]: "DogeOS Wallet",
};

// This is used to check whether it's an Ethereum wallet
export const WALLET_TITLES: Record<WalletEnum, string> = {
  [WalletEnum.METAMASK]: "METAMASK",
  [WalletEnum.WALLETCONNECT]: "WALLETCONNECT",
  [WalletEnum.WALLETLINK]: "WALLETLINK",
  [WalletEnum.BRAVE]: "BRAVE",
  [WalletEnum.EIP6963]: "EIP6963",
  [WalletEnum.PRIVY]: "PRIVY",
  [WalletEnum.PARA]: "PARA",
  [WalletEnum.DOGEOS]: "DOGEOS",
};

/**
 * Maps an SDK wallet-provider kind to the WalletEnum a bridged connection reports
 * as. WEB3REACT has no entry (it uses the connector-instance detection instead).
 */
export const SDK_KIND_TO_WALLET_ENUM: Partial<
  Record<WalletProviderKind, WalletEnum>
> = {
  [WalletProviderKind.PRIVY]: WalletEnum.PRIVY,
  [WalletProviderKind.PARA]: WalletEnum.PARA,
  [WalletProviderKind.DOGEOS]: WalletEnum.DOGEOS,
};

/**
 * True when the wallet is backed by an SDK whose OWN native modal is the wallet
 * picker (Privy/Para/DogeOS). On these chains the app's intermediate
 * "Connect <SDK>" step is redundant, so cancelling the SDK modal should close the
 * whole connect flow rather than fall back to that step.
 */
const SDK_WALLET_ENUMS = new Set<WalletEnum>([
  WalletEnum.PRIVY,
  WalletEnum.PARA,
  WalletEnum.DOGEOS,
]);

export const isSdkWalletEnum = (wallet: unknown): wallet is WalletEnum =>
  typeof wallet === "number" && SDK_WALLET_ENUMS.has(wallet);
